import {
  MapContainer,
  TileLayer,
  Marker,
  LayerGroup,
  GeoJSON,
} from "react-leaflet";
import { icon } from "leaflet";
import countries from "./JsonMaps/asiapac.json";
import europe from "./JsonMaps/Overlays/eur.json";
import middleEast from "./JsonMaps/Overlays/me.json";
import React from "react";
import circle from "../Media/circle.svg";
import LeafletMapMarks from "./Components/LeafletMapMarks";
import regionConfig from "../Config/region";

const LeafletMap = (props) => {
  const tilesetKey = "clbnwkepa000014p3wcbx00qu";

  const onEachFeature = (feature, layer) => {
    //bind click
    layer.on({
      click: () => props.setPositionHandler(feature.properties.NAME),
      mouseover: (event) =>
        props.showTooltipHandler(feature.properties.NAME, event),
      mousemove: (event) => props.moveTooltipHandler(event),
      mouseout: () => props.hideTooltipHandler(),
    });
  };



  const myIcon = (url) =>
    icon({
      iconUrl: `https://acleddata.com/wp-content/icons/svg/${(url)}`,
      iconSize: [20, 20],
      shadowUrl: circle,
      shadowSize: [36, 36],
      shadowAnchor: [18, 16],
    });

  const styleFunction = (feature) => {
    return {
      color: "#614a36",
      fillColor: "#614a36",
      fillOpacity: props.zoomedCountry
        ? feature.properties.NAME === props.zoomedCountry
          ? "0"
          : "0.4"
        : "0",
      weight: "0",
    };
  };

  const markerClickHandler = (country, index) => {
    props.setPositionHandler(country, index);
  };
  return (
    <div style={{ height: props.height, width: props.width }}>
      <MapContainer
        center={props.center}
        zoomSnap={0}
        zoomDelta={0}
        maxBounds={regionConfig(props.region).bounds}
        zoom={props.zoom}
        scrollWheelZoom={false}
        zoomControl={false}
        doubleClickZoom={false}
        dragging={true}
        whenReady={(thisMap) => props.setMap(thisMap.target)}
        style={{ height: props.height, width: props.width, zIndex: 10 }}
      >
        <TileLayer
          url={`https://api.mapbox.com/styles/v1/acled/${tilesetKey}/tiles/512/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYWNsZWQiLCJhIjoiY2w5d29wMXA4MDM3NzN4bm9qMHZpaXB1NSJ9.OA8wiwj1HPnRPcaz-JLfRA`}
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
        />
        <LayerGroup id="overlays">
          <GeoJSON data={middleEast} className="overlay" />
          <GeoJSON data={europe} className="overlay" />
        </LayerGroup>
        <LayerGroup>
          <LeafletMapMarks data={props.newData} sizeScale={props.sizeScale} />
        </LayerGroup>
        <GeoJSON
          ref={props.geoJsonRef}
          data={countries}
          onEachFeature={onEachFeature}
          className="focus-region"
          style={(feature) => styleFunction(feature)}
        />
        <LayerGroup ref={props.iconsRef}>
        {props.trendCountries.map((country,index) => {
          const pos = index === 1 ? props.mapBoxCoords[country.countryLocation].centroid.map(d => d+1.5) : index === 2 ? props.mapBoxCoords[country.countryLocation].centroid.map(d => d-1.5) : props.mapBoxCoords[country.countryLocation].centroid
            return (
              <Marker
                key={`${country.countryLocation}-${index}`}
                position={pos}
                icon={myIcon(country.icon)}
                className="icon-background"
                eventHandlers={{
                  click: () => markerClickHandler(country.countryLocation, index),
                  mouseover: (event) =>
                    {
                      props.showTooltipHandler(
                      props.trendCountries[index].countryTitle,
                      event,
                      props.trendCountries[index].content
                    )},
                  mousemove: (event) => props.moveTooltipHandler(event),
                  mouseout: () => props.hideTooltipHandler(),
                }}
              />
            );
          })}
        </LayerGroup>
      </MapContainer>
    </div>
  );
};

export default LeafletMap;
